export const PRIVACY_POLICY_URL = 'https://vestigas.com/datenschutz';
export const TERMS_AND_CONDITIONS_URL = 'https://vestigas.com/agb';

export const LEGAL_TABS = ['imprint', 'privacy', 'terms'] as const;
export type LegalTab = (typeof LEGAL_TABS)[number];
